import React, { useContext, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { getDetailsGql } from '../gql';
import EventDetails from '../components/EventDetails';
import SuccessSummary from '../components/SuccessSummary';
import { LayoutContext } from '../../../stores/LayoutStore';

function CheckoutSuccessPage() {
  const params = useParams();
  const layoutContext = useContext(LayoutContext);

  const { data } = useQuery(getDetailsGql, {
    variables: {
      slug: params.slug,
    },
  });

  const details = useMemo(() => {
    if (data?.getDetails) return data?.getDetails;
    return {};
  }, [data?.getDetails]);

  useEffect(() => {
    layoutContext.setSlug(params.slug);
  }, [layoutContext, params.slug]);

  return (
    <>
      <EventDetails details={details} />
      <SuccessSummary details={details} />
    </>
  );
}

export default CheckoutSuccessPage;
